import React from 'react';

const PRESS = [
  'YourStory', 'Economic Times', 'Inc42', 'Mint', 'Forbes India', 'TechCrunch',
];

export default function PressStrip() {
  return (
    <section className="bg-white py-10 md:py-14 border-y border-black/[0.05]">
      <div className="max-w-[1280px] mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-center gap-6 md:gap-10">
          <div className="text-[10.5px] font-semibold tracking-[0.22em] text-[#6b6b70] md:border-r md:border-black/10 md:pr-10 whitespace-nowrap">
            FEATURED IN
          </div>
          <div className="flex-1 overflow-hidden">
            <div className="flex flex-wrap items-center gap-x-10 md:gap-x-14 gap-y-4">
              {PRESS.map((p) => (
                <span
                  key={p}
                  className="text-[18px] md:text-[20px] font-semibold tracking-tight text-[#0f0f10]/55 hover:text-[#0f0f10] transition-colors cursor-default whitespace-nowrap"
                  style={{ fontFamily: '"Inter", serif' }}
                >
                  {p}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
